const data = {
  pageName: "MobileMultipleOffers",
  services: {
    translations: {
      url: "offers/MobileMultipleOffers/translations",
      params: {}
    },
    getOffer: {
      url: "offers/MobileMultipleOffers/getOffer",
      params: {}
    },
    productOrdering: {
      url: "offers/MobileMultipleOffers/productOrderingV4",
      params: {}
    },
    submitOfferSR: {
      url: "offers/MobileMultipleOffers/submitOfferSR",
      params: {
        description: ""
      }
    },
    checkClickToCallRequest: {
      url: "clickToCall/checkClickToCallRequest",
      params: {}
    },
    checkClickToCallAvailability: {
      url: "clickToCall/checkClickToCallAvailability"
    },
    getAssetInfo: {
      url: "offers/offerWeb/getHashedPhoneNumber",
      params: {}
    },
    createServiceRequest: {
      url: "offers/offerWeb/createServiceRequest",
      params: {}
    },
    completeRenewalSiebel: {
      url: "offers/offerWeb/completeRenewal",
      params: {}
    },
    createMobileProductOrder: {
      url: "offers/offerWeb/createMobileProductOrder",
      params: {}
    },
    completeRenewalPega: {
      url: "personalizedOffer/activateOffer",
      params: {
        id: ""
      }
    },
    productDetails: {
      url: "newlineup/productDetails",
      params: {}
    }
  },
  asset: {
    body: null,
    callinglist: "callingList",
    click2callButtons: "click2callButtons",
    clicktocallid: "clickTocallId",
    clicktocallphone: "clickToCallPhone",
    clicktocallversion: "clickToCallVersion",
    clicktocallcalendar: "clickToCallCalendar",
    formId: "redStart",
    description: "",
    name: "NewLineUpRedStart",
    subtype: "Forms",
    updateddate: "2020-02-26T12:28:46+0000"
  },
  externalLinks: {
    askHelp: "/exypiretisi/my-vodafone/ananeosi-symvolaiou/",
    otpPage: ""
  }
};

exports.data = data;
